export default class PlayStep {
    constructor(
        play,
        index,
        displayName,
        fragment,
        requiredData,
        state,
        validationMessages
    ) {
        Object.assign(
            this,
            play,
            index,
            displayName,
            fragment,
            requiredData,
            state,
            validationMessages
        );
    }

    isComplete() {
        return this.fragment
            ? this.fragment.isDataComplete(this.requiredData?.name, this.play)
            : true;
    }

    isEditable() {
        return this.requiredData?.isEditable;
    }

    isOptional() {
        return this.fragment
            ? this.fragment.isOptional(this.requiredData?.name)
            : false;
    }
}
